export const themeAction = (payload) => (dispatch) => {
  dispatch({
    type: "THEME_GET",
    payload,
  });
};
